// extracted by mini-css-extract-plugin
module.exports = {"tooltipTrigger":"Tooltip_tooltipTrigger__XfB_u","toolTip":"Tooltip_toolTip__mF4gl"};